<template lang="html">
    <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addStaffConfig.isOpen"
    id="add-staff-sidebar"
  >
    <div class="mt-2 flex items-center justify-between px-6 py-4">
      <h4 class="text-2xl font-bold">Create New Staff</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <div class="sidebar-content p-6">
        <div class="instruction rounded-item mb-5">
            <h3 class="text-lg font-bold pb-4">Instruction</h3>
            <p class="text-sm">This is where you can assign a staff code to your employee so she/he will be able to check out their customers</p>
        </div>

        <div class="info-form">
          <div class="add-staff-avatar-container">
            <!-- <label class="vs-input--label text-lg font-bold">Avatar</label> -->
            <h4 class="text-lg font-bold">Profile picture</h4>
              <avatar-uploader class="my-avatar-uploader" v-if="addStaffConfig.isOpen" :user="staffData" @uploaded-done="handleUploaded"></avatar-uploader>
              <!-- <vs-upload automatic action="http://api.gci.net/v1/gocheckin/staff/form/upload-avatar" :headers="uploadHeader" @on-success="successUpload" :limit="1"/> -->
          </div>

          <!-- <h4 class="text-lg font-bold">Type</h4>
          <div class="flex mb-base">
            <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="staff">staff</vs-radio>
            <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="manager">manager</vs-radio>
            <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="sub-owner">sub-owner</vs-radio>
            <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="owner">owner</vs-radio>
          </div> -->

          <div class="flex mt-3">
            <div class="w-1/2 pr-2">
              <h4 class="text-lg font-bold">Name</h4>
              <vs-input :maxlength="30" v-validate="{required: true, regex: '^[a-zA-Z0-9 ]+$'}" name="name" v-model="name" placeholder="Name" class="w-full" :danger="errors.has('name')"
                :danger-text="StringHelper.getErrorName(errors.first('name'), 'name')"/>
              <!-- <span class="text-danger text-xs error-text-input" v-show="errors.has('name')">{{ errors.first('name') }}</span> -->
            </div>
            <div class="w-1/2 pl-3">
              <h4 class="text-lg font-bold">Code</h4>
              <vs-input v-if="!has_err" :maxlength="6" v-validate="'required'" name="code" v-model="code" placeholder="Code" class="w-full" :danger="errors.has('code')"
                danger-text="The code field is required" @input="isExistCode = false" v-on:keypress="isNumber($event)"/>
              <vs-input v-else :maxlength="6" v-validate="'required'" name="code" v-model="code" placeholder="Code" class="w-full" :danger="has_err"
                :danger-text="`${error_message}`" @input="isExistCode = false, has_err = false" v-on:keypress="isNumber($event)"/>
            </div>
          </div>

          <h4 class="text-lg font-bold mt-base">Nick name</h4>
          <vs-input v-model="nick_name" class="w-full min-length-err" placeholder="Nick name" />

          <!-- <h4 class="text-lg font-bold mt-base">Password</h4>
          <vs-input v-model="password" class="w-full min-length-err" type="password" placeholder="Password" /> -->

          <h4 class="text-lg font-bold mt-base">Cell</h4>
          <vs-input v-model="cell" class="w-full min-length-err" placeholder="Cell" :maxlength="14" v-mask="'(###) ###-####'" type="tel" name="cell" :danger="has_err_phone" :danger-text="err_phone" 
            @input="has_err_phone = false" v-on:keypress="isPhoneNumber($event)" :key="cell_key" />

          <!-- <vs-input v-model="cell" class="w-full min-length-err" placeholder="Cell" :maxlength="14" v-mask="'(###) ###-####'" type="tel" name="cell" :danger="has_err_phone" :danger-text="err_phone" 
            @input="has_err_phone = false" v-on:keypress="isNumber($event)" :key="cell_key" /> -->

            <h4 class="text-lg font-bold mt-base">Email</h4>
            <vs-input
              v-if="!has_err_email"
              :maxlength="30"
              v-validate="'email'"
              name="email"
              v-model="email"
              class="w-full min-length-err"
              :danger="errors.has('email')"
              danger-text="Please enter a valid email"
              placeholder="Email"
              @input="has_err_email = false"
              v-on:keypress="StringHelper.validateEmailChar($event, email)"
            />
            <vs-input
              v-else
              :maxlength="30"
              v-validate="'email'"
              name="email"
              v-model="email"
              class="w-full min-length-err"
              :danger="has_err_email"
              :danger-text="`${error_message_email}`"
              placeholder="Email"
              @input="has_err_email = false"
              v-on:keypress="StringHelper.validateEmailChar($event, email)"
            />

            <h4 class="text-lg font-bold mt-base">Address</h4>
            <vs-input v-model="address" class="w-full min-length-err" placeholder="Address" />
            <!-- <span class="text-danger text-xs error-text-input" v-show="isExistCode">This code already exists</span> -->
            <!-- <span class="text-danger text-xs error-text-input" v-show="errors.has('code')">{{ errors.first('code') }}</span> -->

            <div v-if="permissionList && permissionList.length > 0">
              <h4 class="text-lg font-bold mt-base mb-4">Permission</h4>
              <!-- <div class="flex align-center mb-4">
                <vs-switch v-model="permission.turn" />
                <p class="ml-3" :class="`${permission.turn ? 'text-primary' : 'text-grey-custom'}`">Turn</p>
              </div>
              <div class="flex align-center mb-4">
                <vs-switch v-model="permission.income" />
                <p class="ml-3" :class="`${permission.income ? 'text-primary' : 'text-grey-custom'}`">Income</p>
              </div>
              <div class="flex align-center mb-4">
                <vs-switch v-model="permission.staff_daily_income" />
                <p class="ml-3" :class="`${permission.staff_daily_income ? 'text-primary' : 'text-grey-custom'}`">Staff Daily Income</p>
              </div>
              <div class="flex align-center mb-4">
                <vs-switch v-model="permission.payroll" />
                <p class="ml-3" :class="`${permission.payroll ? 'text-primary' : 'text-grey-custom'}`">Payroll</p>
              </div>
              <div class="flex align-center">
                <vs-switch v-model="permission.batch_history" />
                <p class="ml-3" :class="`${permission.batch_history ? 'text-primary' : 'text-grey-custom'}`">Batch History</p>
              </div> -->
              <div class="flex align-center mb-4" v-for="(permission, index) in permissionList" :key="index">
                <vs-switch v-model="permission.status" />
                <p class="ml-3" :class="`${permission.status ? 'text-primary' : 'text-grey-custom'}`">{{ permission.name }}</p>
              </div>
            </div>

            <div class="pb-base">
              <!-- <label class="text-lg font-bold mb-2">Staff color</label> -->
              <h4 class="text-lg font-bold mt-base mb-2">Color</h4>
              <ul class="clearfix flex flex-wrap">
                <!-- Color Square -->
                <li
                  v-for="(color, index) in themeColors"
                  :key="color"
                  :style="{backgroundColor: color}"
                  class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
                  @click="updatePrimaryColor(color)"
                  :class="{'blur-item': isNewColor || (index >= 0 && index < 20)}"
                >
                <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="color == primaryColor">check</i>
                </li>

                <!-- Custom Color Square -->
                <!-- <li
                  :style="{backgroundColor: customColor}"
                  :class="{'shadow-outline': customColor == primaryColor}"
                  class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
                  @click="updatePrimaryColor(customColor)"
                >
                <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="customColor == primaryColor">check</i>
                </li>

                <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="customColor" type="color" /></li> -->
              </ul>
            </div>
        </div>
    </div>


    <div class="vx-row justify-center my-3" slot="footer">
      <vs-button color="primary" @click="createStaff" style="min-width: 140px;">Create now</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
export default {
  name: "vs-add-staff",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue")
  },
  props: {
    addStaffConfig: {
      type: Object,
      required: true
    },
    // currentPage: {
    //   type: Number,
    //   required: true
    // },
    // itemsPerPage: {
    //   type: Number,
    //   required: true
    // }
    // addStaffData: {
    // type: Object,
    // required: true
    // }
    currentPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      name: "",
      code: "",
      // currentPage: 1,
      itemsPerpage: 10,
      currentColor: this.$store.getters["staffList/themeColors"][0],
      customColor: "#FF9CBB",
      themeColors: this.$store.getters["staffList/themeColors"],
      isExistCode: false,
      error_message: "",
      error_message_email: "",
      has_err: false,
      has_err_email: false,
      err_phone: "",
      has_err_phone: false,
      image: {
        image_url: null,
        delete_image_url: null
      },
      staffData: {
        name: this.name,
        code: this.code,
        color_code: this.primaryColor,
        image_url: this.image
      },
      isOpenLoading: false,
      email: "",
      StringHelper,
      staff_type: 'staff',
      nick_name: '',
      password: '',
      cell: '',
      address: '',
      cell_key: 0,
      // permission: {
      //   turn: false,
      //   income: false,
      //   staff_daily_income: false,
      //   payroll: false,
      //   batch_history: false
      // },
      permissionList: []
    };
  },
  watch: {
    addStaffConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.name = "";
        this.code = "";
        this.email = "";
        this.nick_name = '';
        this.cell = '';
        this.address = '';
        this.primaryColor = this.themeColors[0];
        this.cell_key++;
        // this.errors = [];
        // this.isExistCode = false;
        this.has_err = false;
        this.has_err_email = false;
        this.has_err_phone = false;
        this.errors.clear();
        if (this.addStaffConfig.isOpen) {
          document.body.classList.add("overflow-hidden");
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
        } else {
          document.body.classList.remove("overflow-hidden");
        }

        this.permissionList = this.getPermissionList();
      }
    },
    permissionListData: {
      immediate: true,
      deep: true,
      handler() {
        this.permissionList = this.getPermissionList();
      }
    }
  },
  computed: {
    // primaryColor: {
    //   get()    { return this.$store.state.themePrimaryColor },
    //   set(val) { this.$store.commit('UPDATE_PRIMARY_COLOR', val) }
    // },
    primaryColor: {
      get() {
        return this.currentColor;
      },
      set(value) {
        this.currentColor = value;
      }
    },
    uploadHeader() {
      return { Authorization: "Bearer " + localStorage.getItem("accessToken") };
    },
    permissionListData() {
      return this.$store.getters["staffList/permissionList"];
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    isNewColor() {
      return this.config && this.config.new_color == 1;
    }
  },
  methods: {
    handleUploaded(data) {
      this.image = data;
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Create staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Create staff failed",
            acceptText: "OK"
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    getPermissionList() {
      let data = this.$store.getters["staffList/permissionList"];
      let result = [];
      if(data && data.length > 0) {
        for(let i = 0; i < data.length; i++) {
          result.push({ id: data[i].id, name: data[i].name, status: data[i].status == 1 ? true : false });
        }
      }
      return result;
    },
    myMaskedNumber(str) {
      let result = "(";
      let number = ('' + str).replace(/[^\d]/g, '');
      result += number.substr(0, 3);
      if(result.length == 4) {
        result += ") ";
      }
      result += number.substr(3, 3);
      if(result.length == 9) {
        result += "-";
      }
      result += number.substr(6);
      this.cell = result;
      return result;
    },
    isPhoneNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        if(charCode >= 48 && charCode <= 57 && this.cell.length < 14) {
          this.myMaskedNumber(this.cell);
        }
        return true;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updatePrimaryColor(color) {
      this.primaryColor = color;
      // this.$vs.theme({ primary: color });
    },
    closeSidebar() {
      this.$emit("CloseSidebar");
    },
    successUpload(response) {
      console.log(response);
    },
    createStaff() {
      let phone_num = ('' + this.cell).replace(/[^\d]/g, '');
      if (this.name != "" && this.code.length >= 3 && this.errors.items.length == 0 && this.errors.first('name') == undefined && (phone_num.length == 10 || phone_num == '')) {
        if (!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        const staff = {
          staff_name: this.name,
          staff_code: this.code,
          color_code: this.primaryColor,
          image_url: this.image.image_url,
          address: this.address,
          phone: phone_num,
          nick_name: this.nick_name,
          page:
            this.$store.getters["staffList/staffData"]._meta.totalCount % 10 ==
            0
              ? this.$store.getters["staffList/staffData"]._meta.pageCount + 1
              : this.$store.getters["staffList/staffData"]._meta.pageCount,
          "per-page": this.itemsPerpage,
          email: this.email,
        };
        let list_permission = [];
        if(this.permissionList && this.permissionList.length > 0) {
          for(let i = 0; i < this.permissionList.length; i++) {
            list_permission.push({
              id: this.permissionList[i].id,
              status: this.permissionList[i].status ? 1 : 0
            });
          }
        }
        staff.list_permission = list_permission;
        // console.log(this.$store.getters["staffList/staffData"]._meta.totalCount)
        this.$store
          .dispatch("staffList/ADD_STAFF", staff)
          .then((res) => {
            staff.user_id = res.employee.user_id;
            this.name = "";
            this.code = "";
            if (this.has_err == false) {
              this.closeSidebar();
            }
            // console.log(this.$store.getters["staffList/staffData"]._meta.totalCount);
            // if(this.$store.getters["staffList/staffData"]._meta.totalCount % 10 == 0) {
            this.$emit("AddStaff", staff);
            this.closeLoading();
            this.$vs.notify({
              title: "Notification",
              text: "Add Staff Success",
              color: "success",
              position: "top-right"
            });
            // }
          })
          .catch(err => {
            if (err.staffCode) {
              this.error_message = err.staffCode[0];
              this.has_err = true;
            }
            if (err.email) {
              this.error_message_email = err.email[0];
              this.has_err_email = true;
            }
            this.closeLoading();
          });
      } else {
      //  if (this.code.length != 3) {
       if (this.code.length < 3) {
          this.has_err = true;
          // this.error_message = "The code must contain exactly 3 digits.";
          this.error_message = "Staff code must contain at least 3 digits.";
        }
        if(phone_num.length != 10 && phone_num.length != 0) {
          this.has_err_phone = true;
          this.err_phone = "Phone number must contain exactly 10 digits.";
        }
      }

      this.$validator.validateAll();
    }
  }
};
</script>
